package pl.mothdigital.neuronowi.pages.specialists

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.layout.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.components.*
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.sections.cta.*
import pl.mothdigital.neuronowi.components.sections.specialist.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import org.jetbrains.compose.web.css.keywords.auto
import pl.mothdigital.neuronowi.theme.SiteTheme

private val specializations = listOf(
    SpecialistData(
        icon = { FaBrain() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_NEUROLOGIA_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_NEUROLOGIA_DESC
    ),
    SpecialistData(
        icon = { FaTeeth() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_ORTOGNATYCZNA_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_ORTOGNATYCZNA_DESC
    ),
    SpecialistData(
        icon = { FaWind() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_BUTEJKO_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_BUTEJKO_DESC
    ),
    SpecialistData(
        icon = { FaHandHoldingMedical() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_CASTILLO_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_CASTILLO_DESC
    ),
    SpecialistData(
        icon = { FaChild() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_PADOVAN_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_PADOVAN_DESC
    ),
    SpecialistData(
        icon = { FaTeethOpen() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_MFS_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_MFS_DESC
    ),
    SpecialistData(
        icon = { FaPersonWalking() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_GOPEX_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_GOPEX_DESC
    ),
    SpecialistData(
        icon = { FaFaceSmile() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_MIOFUNKCJONALNA_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_MIOFUNKCJONALNA_DESC
    ),
    SpecialistData(
        icon = { FaHandsHolding() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_MASAZ_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_MASAZ_DESC
    ),
    SpecialistData(
        icon = { FaHandsHolding() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_KINESIOTAPING_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_KINESIOTAPING_DESC
    ),
    SpecialistData(
        icon = { FaHandsHolding() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_ELEKTROSTYMULACJA_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_ELEKTROSTYMULACJA_DESC
    ),
    SpecialistData(
        icon = { FaHandHoldingMedical() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_SSZ_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_SSZ_DESC
    ),
    SpecialistData(
        icon = { FaHandsHolding() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_REKA_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_REKA_DESC
    ),
    SpecialistData(
        icon = { FaHandsHolding() },
        title = StringResources.MAGDALENA_NOWIK_SPEC_NEUROTAKTYLNA_TITLE,
        description = StringResources.MAGDALENA_NOWIK_SPEC_NEUROTAKTYLNA_DESC
    )
)

private val servicesColumn1 = listOf(
    StringResources.MAGDALENA_NOWIK_SERVICE_1,
    StringResources.MAGDALENA_NOWIK_SERVICE_2,
    StringResources.MAGDALENA_NOWIK_SERVICE_3,
    StringResources.MAGDALENA_NOWIK_SERVICE_4,
    StringResources.MAGDALENA_NOWIK_SERVICE_5
)
private val servicesColumn2 = listOf(
    StringResources.MAGDALENA_NOWIK_SERVICE_6,
    StringResources.MAGDALENA_NOWIK_SERVICE_7,
    StringResources.MAGDALENA_NOWIK_SERVICE_8,
    StringResources.MAGDALENA_NOWIK_SERVICE_9
)
private val servicesColumn3 = listOf(
    StringResources.MAGDALENA_NOWIK_SERVICE_10,
    StringResources.MAGDALENA_NOWIK_SERVICE_11,
    StringResources.MAGDALENA_NOWIK_SERVICE_12,
    StringResources.MAGDALENA_NOWIK_SERVICE_13
)

private val priceItems = listOf(
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_1_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_1_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_1_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_2_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_2_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_2_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_3_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_3_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_3_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_4_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_4_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_4_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_5_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_5_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_5_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_6_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_6_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_6_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_7_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_7_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_7_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_8_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_8_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_8_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_9_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_9_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_9_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_10_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_10_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_10_AMOUNT
    ),
    PriceItem(
        StringResources.MAGDALENA_NOWIK_PRICE_11_NAME,
        StringResources.MAGDALENA_NOWIK_PRICE_11_TIME,
        StringResources.MAGDALENA_NOWIK_PRICE_11_AMOUNT
    )
)

@Page
@Composable
fun MagdalenaNowikPage() {
    SpecialistPageLayout(
        title = StringResources.MAGDALENA_NOWIK_PAGE_TITLE,
        headerSection = { HeaderSection() },
        profileSection = { ProfileSection() },
        specializationsSection = { SpecializationsSection() },
        servicesSection = { ServicesSection() },
        priceSection = { PriceSection() },
        ctaSection = { context ->
            CTASection(
                ctx = context,
                customAction = { js("window.scrollTo({ top: 0, behavior: 'smooth' })") },
            )
        }
    )
}

@Composable
private fun HeaderSection() {
    SpecialistHeaderSection(
        name = StringResources.MAGDALENA_NOWIK_HEADER_NAME,
        titles = StringResources.MAGDALENA_NOWIK_HEADER_SUBTITLE,
        phoneNumber = StringResources.MAGDALENA_NOWIK_PHONE
    )
}

@Composable
private fun ProfileSection() {
    SpecialistProfileSection(
        avatar = ImageResources.avatarMagdalenaNowik,
        aboutTitle = StringResources.MAGDALENA_NOWIK_O_MNIE_TITLE,
        aboutParagraphs = listOf(
            StringResources.MAGDALENA_NOWIK_O_MNIE_TEXT_1,
            StringResources.MAGDALENA_NOWIK_O_MNIE_TEXT_2,
            StringResources.MAGDALENA_NOWIK_O_MNIE_TEXT_3,
            StringResources.MAGDALENA_NOWIK_O_MNIE_TEXT_4,
            StringResources.MAGDALENA_NOWIK_O_MNIE_TEXT_5,
            StringResources.MAGDALENA_NOWIK_O_MNIE_TEXT_6
        ),
        inviteMessage = StringResources.MAGDALENA_NOWIK_O_MNIE_INVITE,
        imagePosition = ImagePosition.LEFT
    )
}

@Composable
private fun SpecializationsSection() {
    SpecializationsGridSection(
        title = StringResources.MAGDALENA_NOWIK_SPECIALIZATIONS_TITLE,
        specializations = specializations
    )
}

@Composable
private fun ServicesSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.MAGDALENA_NOWIK_SERVICES_TITLE.fixPolishOrphans()) }
            
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) {
                Text(StringResources.MAGDALENA_NOWIK_SERVICES_INTRO.fixPolishOrphans())
            }
            
            SimpleGrid(
                modifier = Modifier.fillMaxWidth().gap(1.cssRem),
                numColumns = numColumns(base = 1, sm = 1, md = 2, lg = 3, xl = 3)
            ) {
                Column(modifier = Modifier.gap(0.5.cssRem)) {
                    Ul { servicesColumn1.forEach { Li { Text(it.fixPolishOrphans()) } } }
                }
                Column(modifier = Modifier.gap(0.5.cssRem)) {
                    Ul { servicesColumn2.forEach { Li { Text(it.fixPolishOrphans()) } } }
                }
                Column(modifier = Modifier.gap(0.5.cssRem)) {
                    Ul { servicesColumn3.forEach { Li { Text(it.fixPolishOrphans()) } } }
                }
            }
        }
    }
}

@Composable
private fun PriceSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50.toRgb().copy(alpha = 128))
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.MAGDALENA_NOWIK_PRICE_TITLE.fixPolishOrphans()) }

            Column(modifier = Modifier.gap(0.5.cssRem)) {
                AppP(modifier = Modifier.fontSize(0.9.cssRem).margin(bottom = 0.px)) { Text(StringResources.MAGDALENA_NOWIK_PRICE_HEADER_1.fixPolishOrphans()) }
                AppP(modifier = Modifier.fontSize(0.9.cssRem).margin(bottom = 0.px)) { Text(StringResources.MAGDALENA_NOWIK_PRICE_HEADER_2.fixPolishOrphans()) }
                AppP(modifier = Modifier.fontSize(0.9.cssRem).margin(bottom = 1.cssRem)) { Text(StringResources.MAGDALENA_NOWIK_PRICE_HEADER_3.fixPolishOrphans()) }
            }

            SpecialistPriceTable(priceItems = priceItems)

            Column(modifier = Modifier.gap(0.2.cssRem)) {
                AppP(modifier = Modifier.fontSize(0.9.cssRem).margin(bottom = 0.px), color = SiteTheme.black._700) {
                    Text(StringResources.MAGDALENA_NOWIK_PRICE_NOTE.fixPolishOrphans())
                }
                AppP(modifier = Modifier.fontSize(0.9.cssRem).margin(bottom = 0.px), color = SiteTheme.black._700) {
                    Text(StringResources.MAGDALENA_NOWIK_PRICE_NOTE_2.fixPolishOrphans())
                }
                AppP(modifier = Modifier.fontSize(0.9.cssRem).margin(bottom = 0.px), color = SiteTheme.black._700) {
                    Text(StringResources.MAGDALENA_NOWIK_PRICE_NOTE_3.fixPolishOrphans())
                }
            }
        }
    }
}
